import { Proposal, Sow } from "../capTypes";

const hasCapSelfSupplyPercent = (value: number | undefined | null): boolean =>
  value !== undefined && value !== null && Number.isFinite(Number(value));

const hasCapSowAnnualSelfSupply = (sow: Sow | undefined): boolean =>
  hasCapSelfSupplyPercent(sow?.annualPercentSelfSupply);

const hasCapSowOriginalSelfSupply = (sow: Sow | undefined): boolean =>
  hasCapSelfSupplyPercent(sow?.originalProposal?.annualPercentSelfSupply);

/** Full solar + battery (excludes solar-only and battery-only packages). */
const capProposalHasSolarAndBattery = (
  proposal: Proposal | undefined
): boolean => {
  const productPackage = proposal?.ProductPackage ?? "";
  if (
    productPackage === "Retrofit Storage" ||
    productPackage.includes("Standalone Storage")
  ) {
    return false;
  }

  const parts = productPackage
    .split(";")
    .map((part) => part.trim().toLowerCase());
  const hasSolar = parts.some((part) => part.includes("solar"));
  const hasBattery = parts.some(
    (part) =>
      part.includes("battery") ||
      part.includes("storage") ||
      part.includes("brightbox")
  );

  return hasSolar && hasBattery;
};

export {
  capProposalHasSolarAndBattery,
  hasCapSelfSupplyPercent,
  hasCapSowAnnualSelfSupply,
  hasCapSowOriginalSelfSupply,
};
